import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormClasificadorEstadistico from './FormClasificadorEstadistico';

import updateClasificadorEstadistico from '../../../../graphql/mutations/clasificadores/updateClasificadorEstadistico.graphql';
import getClasificadorEstadisticoPorId from '../../../../graphql/querys/clasificadores/getClasificadorEstadisticoPorId.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(updateClasificadorEstadistico, {
  name: 'updateClasificadorEstadistico',
})
class EditarClasificadorEstadistico extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      loading: true,
      clasificadorEstadistico: {},
    };

    this.props.client
      .query({
        query: getClasificadorEstadisticoPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const clasificadorEstadistico =
          res.data.getClasificadorEstadisticoPorId;
        this.setState({
          loading: false,
          clasificadorEstadistico: clasificadorEstadistico,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarClasificadorEstadistico = this.guardarClasificadorEstadistico.bind(
      this
    );
    this.onCancel = this.onCancel.bind(this);
  }

  guardarClasificadorEstadistico(clasificadorEstadistico) {
    this.setState(
      {
        clasificadorEstadistico: {
          ...this.state.clasificadorEstadistico,
          ...clasificadorEstadistico,
        },
      },
      function() {
        let nuevoClasificadorEstadistico = this.state.clasificadorEstadistico;
        delete nuevoClasificadorEstadistico.__typename;
        delete nuevoClasificadorEstadistico._id;

        this.props
          .updateClasificadorEstadistico({
            variables: {
              _id: this.props.match.params.id,
              nuevoClasificadorEstadistico: this.state.clasificadorEstadistico,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description:
                'Se ha registrado los nuevos datos de la clasificador estadistico',
            });

            this.props.history.push('/admin/otros/clasificadoresEstadisticos');
          })
          .catch(err => {
            console.log(
              'Error en la actualizacion del clasificador estadistico'
            );
            console.log(err);
            errorService(err, {
              _id: this.props.match.params.id,
              nuevoClasificadorEstadistico: this.state.clasificadorEstadistico,
            });
            Modal.error({
              title: 'Error en la actualizacion de la clasificadorEstadistico',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Clasificador Estadistico</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Clasificador Estadistico
          </h2>
          <br />
          <div style={estiloContent}>
            <FormClasificadorEstadistico
              className="formularios"
              onSubmit={this.guardarClasificadorEstadistico}
              onAnterior={() =>
                this.props.history.push(
                  '/admin/otros/clasificadoresEstadisticos'
                )
              }
              datos={this.state.clasificadorEstadistico}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarClasificadorEstadistico);
